import { render, staticRenderFns } from "./Trashes.vue?vue&type=template&id=7008b6bc&scoped=true"
import script from "./Trashes.vue?vue&type=script&lang=js"
export * from "./Trashes.vue?vue&type=script&lang=js"
import style0 from "./Trashes.vue?vue&type=style&index=0&id=7008b6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008b6bc",
  null
  
)

export default component.exports